import React, {useEffect, useState} from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import SearchSection from '../Reusables/SearchSection';
import Spinner from '../Reusables/Spinner';
import TableView from '../Reusables/TableView';
import getResponse from '../actions/Brands.js';
import '../../scss/brands.scss';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList, parseDataList, parseTableHeaders } from '../../store/Actions';
import DeleteItem from '../popups/DeleteItem';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';

function Brands() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const filename = 'Portals';
    const [isDeleted, setDeleted] = useState(false);
    const[isLoading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [deleteBrandId, setDeleteBrandId] = useState(null);
    const [brandsList, setBrandsList] = useState(null);
    const [open, setOpen] = useState(null);
    const [errormessage, setErrorMessage] = useState('');
    const [openPopup, setOpenPopup] = useState(false);
    
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Portals", "url": "portals/list" }
    ];
    const tableHeaders = [
        { "name": "", "sort": false, "width": "50px" },
        { "name": "Portal", "sort": false, "width": "150px" },
        // { "name": "Email Id", "sort": false, "width": "180px" },
        // { "name": "Phone", "sort": false, "width": "140px" },
        { "name": "Address", "sort": false, "width": "180px" },
        { "name": "Actions", "sort": false, "width": "70px" }
    ];
    const searchValues = {
        isFilter: false,
        isCreate: true,
        placeholder: "Search Portal",
    };
    const headers = [
        { label: "Portal", key: "name" },
        // { label: "Email Id", key: "email" },
        // { label: "Phone", key: "phoneNumber" },
        { label: "Address", key: "address" }
    ];

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(parseTableHeaders(tableHeaders));
        dispatch(parseBreadcrumbsList(breadcrumbsList));
        const path = new URLSearchParams(location.search);
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                if (path.has('search')) {
                    const query = path.get('search');
                    accesstoken && callBrandListApi(`/api/brand/list?search=${query}`, accesstoken);

                } else {
                    accesstoken && callBrandListApi('/api/brand/list', accesstoken);
                }
            }
        }
        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [isDeleted])

    const callBrandListApi = (endpoint, accesstoken) => {
        getResponse.GetBrandList(endpoint, accesstoken, (data) => {
            if (data.status == 200) {
                console.log("Fetched data", data.data.data);
                dispatch(parseDataList(data.data.data));
                setLoading(false);
                setBrandsList(data.data.data);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    const callSearchApi = (query) => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                callBrandListApi(`/api/brand/list?search=${query}`, accesstoken);
                navigate(`/portals/list/?search=${query}`);
            }
        }
        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const toCreateNewBrand = () => {
        navigate('/portals/new');
    }

    const getDetails = (brandId, type) => {
        console.log("Clicked Brand id", brandId);
        if(type == 'edit') {
            navigate(`/portals/${brandId}/edit`);
        } else if(type == 'overview') {
            navigate(`/portals/${brandId}/view`);
        }
    }

    const deleteBrand = () => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.DeleteBrand(`/api/brand/delete?brandId=${deleteBrandId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        console.log("Delete Brand", data.data.data);
                        setDeleted(!isDeleted);
                        handleClose();
                        setOpenPopup(false);
                    } else if(data.status == 401) {
                        navigate("/login")
                    } else {
                        setErrorMessage(data.data.message);
                        setOpen(true);
                        setOpenPopup(true);
                    }
                });
            }
        }
        RefreshToken((accesstoken) => callApi(accesstoken));
    }
 
    return (
        <div className='brands-container'>
            <Header />

            <div className='row brands-sub-container'>
                <Sidebar />

                <div className='col-10 brands-body-container'>
                    <div className='sub-header'>
                        <Breadcrumbs/>
                        <SearchSection values={searchValues} handleFilter="" setDownloadtype="" downloadtype=""
                            downloadarray={brandsList} headers={headers} filename={filename}
                            callSearchApi={(query) => callSearchApi(query)}  navigateTo={toCreateNewBrand} pageType="Brands"/>               
                    </div>
                    <div className='table-body'>
                        {isLoading ?
                        (<Spinner/>) :
                        (<TableView getDetails={(brandId, type) => getDetails(brandId, type)} 
                         handleShow={handleShow}
                        setDelete={(id) => setDeleteBrandId(id)} page="Brands"
                        callSortApi=""
                        sortValues=""/>)}
                    </div>
                </div>
            </div>

            <Footer />

            {/* Showing delete popup */}
            {/* <EnableDNS show={redirect} handleClose={handleDisable} page="brand"/> */}
            <DeleteItem show={show} handleClose={handleClose} deleteApiCall={deleteBrand} enable={true}/>
            <Snackbars error={errormessage} open={openPopup} setOpen={setOpenPopup}/>
        </div>
    );
}

export default Brands;